<template>
  <v-img :width="32" :src="Source"></v-img>
</template>

<style scoped>

</style>

<script>
  import CellImage from "./cellImage.ts";
  export default CellImage;
</script>